var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control ds-form-item ds-code-set", class: _vm.getCss },
    [
      _vm.simple && _vm.readOnly && !_vm.isDesign
        ? [
            _c(
              "DsfTextProxy",
              _vm._b(
                {
                  model: {
                    value: _vm.selectValue,
                    callback: function ($$v) {
                      _vm.selectValue = $$v
                    },
                    expression: "selectValue",
                  },
                },
                "DsfTextProxy",
                _vm._self.$props,
                false
              )
            ),
            _vm._t("error", function () {
              return [
                _vm.errors.length > 0
                  ? _c("div", { staticClass: "ds-error-text" }, [
                      _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                    ])
                  : _vm._e(),
              ]
            }),
          ]
        : [
            _vm.showLabel
              ? _c(
                  "DsfFieldLabel",
                  {
                    style: _vm.getLabelWidthStyle(),
                    attrs: {
                      mode: _vm.showDataCaptionMode,
                      "show-icon": _vm.showDataCaptionIcon,
                      trigger: _vm.showDataCaptionTrigger,
                      "data-caption": _vm.dataCapion,
                      "is-design": _vm.isDesign,
                      owner: _vm._self,
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t(_vm.label)) + " ")]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "ds-form-block",
                style: _vm.getFormItemBlockMarginLeft(),
              },
              [
                !_vm.readOnly
                  ? _c(
                      "div",
                      {
                        staticClass: "ds-code-set-default",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.clickHandler.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            class: { "hidden-border": !_vm.showBorder },
                            attrs: {
                              placeholder: _vm.placeholder,
                              readonly: true,
                              disabled: _vm.disabled,
                              clearable: _vm.clearable,
                            },
                            model: {
                              value: _vm.selectValue,
                              callback: function ($$v) {
                                _vm.selectValue = $$v
                              },
                              expression: "selectValue",
                            },
                          },
                          [
                            !_vm.clearable || !_vm.selectValue
                              ? _c("i", {
                                  ref: "icon_arrow_down",
                                  staticClass:
                                    "el-input__icon el-icon-arrow-down",
                                  attrs: { slot: "suffix" },
                                  slot: "suffix",
                                })
                              : [
                                  _c("i", {
                                    staticClass:
                                      "el-input__icon el-icon-circle-close clearable-close",
                                    attrs: { slot: "suffix" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.clear.apply(null, arguments)
                                      },
                                    },
                                    slot: "suffix",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "el-input__icon el-icon-arrow-down clearable-arrowdown",
                                    attrs: { slot: "suffix" },
                                    slot: "suffix",
                                  }),
                                ],
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm.readOnly
                  ? _c(
                      "div",
                      { staticClass: "ds-form-readonly" },
                      [
                        _c(
                          "DsfTextProxy",
                          _vm._b(
                            {
                              attrs: { "show-label": false },
                              model: {
                                value: _vm.selectValue,
                                callback: function ($$v) {
                                  _vm.selectValue = $$v
                                },
                                expression: "selectValue",
                              },
                            },
                            "DsfTextProxy",
                            _vm._self.$props,
                            false
                          )
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._t("error", function () {
                  return [
                    _vm.errors.length
                      ? _c("div", { staticClass: "ds-error-text" }, [
                          _vm._v(_vm._s(_vm.errorsMsg)),
                        ])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }